import { render, staticRenderFns } from "./sendIcsMail.vue?vue&type=template&id=28e390a0&"
import script from "./sendIcsMail.vue?vue&type=script&lang=js&"
export * from "./sendIcsMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports